import { render, staticRenderFns } from "./MpFooter.vue?vue&type=template&id=5b66c86a&scoped=true"
import script from "./MpFooter.vue?vue&type=script&lang=js"
export * from "./MpFooter.vue?vue&type=script&lang=js"
import style0 from "./MpFooter.vue?vue&type=style&index=0&id=5b66c86a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b66c86a",
  null
  
)

export default component.exports